import React, { useEffect, useState } from 'react'
import { Col, Row, Table } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { CSVLink } from 'react-csv'
import { fetchReportTasks } from '../../../services/httpClient';
import ReactPaginate from 'react-paginate'

interface TasksCompletedTableState {
  data?: any[];
  startDate?: string;
  endDate?: string;
  useDatePicker?: boolean;
}

export const TasksCompletedTable = ({ data, startDate, endDate, useDatePicker = false }: TasksCompletedTableState) => {
  const [taskData, setTaskData] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const pageCount = Math.ceil(taskData.length / itemsPerPage);
  const offset = currentPage * itemsPerPage;
  const currentData = taskData.slice(offset, offset + itemsPerPage);

  useEffect(() => {
    const fetchData = async () => {
      if (data || data === 0) {
        setTaskData(data);
      } else {
        const starting = new Date();
        starting.setDate(starting.getDate() - 365);
        let start = starting.toISOString().slice(0, 10);
        let end = new Date().toISOString().slice(0, 10);
        if (useDatePicker) {
          start = startDate ?? start;
          end = endDate ?? end;
        }
        await getTaskData(start!, end!);
      }
    }
    fetchData();
  }, [data, startDate, endDate, useDatePicker]);

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    const second = String(now.getSeconds()).padStart(2, "0");
    return `${year}${month}${day}${hour}${minute}${second}`;
  };

  const getTaskData = async (start: string, end: string) => {
    fetchReportTasks(start, end)
      .then((res: any) => {
        const tasks = res[0].data;
        const sortedTasks = tasks.sort((a: any, b: any) => (a.cm_reviewed_at < b.cm_reviewed_at ? 1 : -1));
        setTaskData(sortedTasks);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const taskHeaders = [
    { label: "ID", key: "id" },
    { label: "Task Name", key: "task_name" },
    { label: "Completed Date", key: "cm_reviewed_at" },
    { label: "Goal ID", key: "goal_id" },
    { label: "Goal Name", key: "goal_name" },
    { label: "Case ID", key: "case_id" },
    { label: "Case Name", key: "case_name" },
    { label: "Assigned To", key: "goal_subject.name" },
  ];

  return (
    <>
      <Row>
        <Col>
          <h5 className="app-header-text">Tasks Completed</h5>
        </Col>
        <Col className="text-end">
          {data && (
            <CSVLink
              id="download-tasks-button"
              data={taskData}
              headers={taskHeaders}
              filename={`tasks${getCurrentDateTime()}.csv`}
              className="btn button app-tertiary-color"
              target="_blank"
            >
              <FontAwesomeIcon icon={faDownload} />
            </CSVLink>
          )}
        </Col>
      </Row>
      <Row className="mb-5">
        <Col className="col-12">
          <Table striped>
            <thead>
              <tr>
                <th>Case Name</th>
                <th>Assigned To</th>
                <th>Task</th>
                <th>Goal</th>
                <th>Completed</th>
              </tr>
            </thead>
            <tbody>
              {currentData?.map((d: any) => (
                <tr key={d.id}>
                  <td>{d.case_name}</td>
                  <td>{d.goal_subject?.name}</td>
                  <td>{d.task_name}</td>
                  <td>{d.goal_name}</td>
                  <td className="text-nowrap">{d.cm_reviewed_at}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          {pageCount > 1 && (
            <div id="tasks-pagination" style={{ position: 'relative', zIndex: 0 }}>
              <ReactPaginate
                previousLabel={"← Previous"}
                nextLabel={"Next →"}
                pageCount={pageCount}
                onPageChange={(event: { selected: number }) => setCurrentPage(event.selected)}
                containerClassName={"pagination justify-content-center"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                activeClassName={"active"}
                forcePage={currentPage}
              />
            </div>
          )}
        </Col>
      </Row>
    </>
  );
};
